import classNames from 'classnames';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import AutosizeInput from 'react-input-autosize';
import styles from './InlineInput.module.scss';

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'ref'> {
  indicatorClassName?: string;
  editableIndicator?: boolean;
  hideFromFullstory?: boolean;
  variant?: 'default' | 'h2' | 'subheading';
}

interface State {
  isFocused: boolean;
}

export default class InlineInput extends Component<Props, State> {
  static defaultProps: Partial<Props> = {
    editableIndicator: true,
    variant: 'default',
  };

  state = {
    isFocused: false,
  };

  handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    this.setState({ isFocused: true });
    this.props.onFocus?.(event);
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    this.setState({ isFocused: false });
    this.props.onBlur?.(event);
  };

  render() {
    const {
      className,
      hideFromFullstory,
      variant,
      editableIndicator,
      indicatorClassName,
      ...rest
    } = this.props;
    const containerClass = classNames(
      styles.container,
      styles[`variant-${variant}`],
      {
        'fs-mask': hideFromFullstory,
      },
      className
    );

    const input = (
      <AutosizeInput
        {...rest}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        className={containerClass}
      />
    );

    // Plan autosized input with minimal markup:
    if (!editableIndicator) return input;

    // Input with editable indicator
    const indicatorClass = classNames(
      styles.indicator,
      styles[`variant-${variant}`],
      {
        [styles.hasValue]: !!this.props.value,
        [styles.inputInFocus]: this.state.isFocused,
      },
      indicatorClassName
    );

    return (
      <div className={styles.indicatorContainer}>
        <div className={indicatorClass}>
          <FontAwesome name="pencil" />
        </div>
        {input}
      </div>
    );
  }
}
